import React from 'react'
import '../../App.css'

function Loading() {
    return (
        <div className='loader'/>
    )
}

export default Loading